import {Component, OnInit, ViewChild} from '@angular/core';
import {AdminService} from '../service/admin.service';
import {LoadingController, ModalController, Platform, ToastController} from '@ionic/angular';
import {NgForm} from '@angular/forms';
import {AuthService} from '../service/auth.service';
import {Constant} from '../shared/model/Constant';
import { MapGeolocationComponent } from '../map-geolocation/map-geolocation.component';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.page.html',
  styleUrls: ['./supplier.page.scss'],
})
export class SupplierPage implements OnInit {
  @ViewChild('form', {static: false}) ngForm: NgForm;
  tradeName: any;
  document: any;
  select = false;
  contacts: any[] = [{}];
  formulary: [];
  documents: any;
  loading: any;
  fileType: string;
  fileUrl: string;
  typeaccount: any;
  bank: any;
  typeaccounts: any[];
  banks: any[];
  accountNumber: any;
  countries: any[];
  departments: any[];
  cities: any[];
  showSeparator = false;
  areas: any;
  activities: any[] = [];
  filteredActivities: any[] = [];
  selectedActivity: any = null;
  urlRutUploaded: string;
  urlIdPhotocopyUploaded: string;
  urlBankCertificationUploaded: string;
  urlContractUploaded: string;
  typeProviders: any;
  flagNaturalPerson: boolean;
  typeProviderId: number;
  firstName: any;
  secondName: any;
  firstLastName: any;
  phone: any;
  nitdigit: any;
  socialNetworks: any;
  socialNetworkn: any[] = [{}];
  webPage: string;
  taxRegimes: any;
  taxRegimeId: number;
  providerId: string;
  documentRep: any;
  configCourt: any[]=[{}];//este arreglo se editara para alterar las opciones de los campos desplegables
  originalConfigCourt: any[]=[{}];// auxiliar que guarda los valores originales de configuraciones de cor+te
 typeSettlement: any[]=[{}];//
  typeCourts: any[]=[{}];//
  filteredConfigCourt: any[]=[];//
  settlementTypeId: any;//
  isFormBasicDataComplete = false;
  isFormAccountingInformation = false;
  isFormContacts = false;
  isFormSocialNetworkn = false;
  isFormDocuments = false;
  isFormStatements = false;
  isFormBilling = false;
  isFormPayments = false;
  isFormCuts = false;
  isFormProduct = false;
  cellPhoneRep: any;
  url: string;
  otherCheckbox: boolean = false;
  phoneRep: any;
  paymentMethods: any[];
  days = Array.from({length: 30}, (_, i) => i + 1);
  secondSurName: any;
  registeredBy: any;
  classCiiu: string;
  name: any;
  disableSaveButton = false;   //expresion para deshabilitar el boton de guardar en seccion informacion contable
  //Para geolocalizacion
  address: any;
  cityName: any;
  latUser: any;
  lngUser: any;
  plusCodeUser: any;
  modalOpen: any;
  isMobile: any;

  constructor(
    private authService: AuthService,
    public toastController: ToastController,
    public modalController: ModalController,
    private adminService: AdminService,
    public loadingController: LoadingController,
    private platform: Platform
  ) {

  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });

    this.getCountries();
    this.getDepartmentsCountries();
    this.getCities();
    this.getTypeIdentificationId();
    this.getAreaDirectories();
    this.getBusinessActivityCiiu();
    this.getTypeProviders();
    this.getSocialNetworks();
    this.getFiscalResponsibility();
    this.getPaymentMethods();
    this.getTypeaccountbank();
    this.getBanks();
    this.filteredActivities = [];
    this.getTypeCourtsFrequencies();               //metodos para extraer info de cortes
    this.getTypesSettlement();
    this.getConfigCourt();
    this.verifyPlatform();
  }

  async loadMap() {
    try {
      if (!this.address) {
        this.presentToast("Por favor ingresa una dirección para abrir el mapa");
        return
      }
      if (this.modalOpen) {
        console.log("Ya hay un modal abierto.");
        return
      } 
      const modal = await this.modalController.create({
        component: MapGeolocationComponent,
        componentProps: {
          address: this.address || null,
          cityName: this.cityName || null,
          latUser: this.latUser || null,
          lngUser: this.lngUser || null
        }
      });
      this.modalOpen = true;
      await modal.present();
      await modal.onWillDismiss().then((response: any) => {
        const data = response.data;
        if (data) {
          console.log('Resultado del proceso de geolocalización', data);
          this.address = data.address;
          this.latUser = data.latitude;
          this.lngUser = data.longitude;
          this.plusCodeUser = data.plusCode;
          this.presentToast("Datos de la ubicación seleccionada obtenidos exitosamente")
        } else {
          this.presentToast("No se pudo realizar el proceso de geolocalización");
        }
        this.modalOpen = false;
      });
    } catch (error) {
      console.error("Error en el proceso de localizacion de los datos geograficos", error);
      this.modalOpen = false;
    }
  }

  verifyPlatform() {
    console.log('platform: ', this.platform.platforms());
    if (this.platform.is('desktop')) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  validateOnlyLetters() {
    if (this.firstName) {
      this.firstName = String(this.firstName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondName) {
      this.secondName = String(this.secondName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.firstLastName) {
      this.firstLastName = String(this.firstLastName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    if (this.secondSurName) {
      this.secondSurName = String(this.secondSurName).replace(/[^a-zA-ZñÑ]/g, '').substring(0, 50);
    }
    
  }

  validateOnlyLettersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.name) {
      contact.name = contact.name.replace(/[^a-zA-ZñÑ\s]/g, '');
    }
  }


  validateOnlyNumbers() {
    if (this.document) {
      this.document = this.document.replace(/\D/g, '');
      this.document = this.document.substring(0, 20);

    }
    if (this.phone) {
      this.phone = this.phone.replace(/\D/g, '');
      this.phone = this.phone.substring(0, 11);
    }
    if (this.nitdigit) {
      this.nitdigit = this.nitdigit.replace(/\D/g, '');
      this.nitdigit = this.nitdigit.substring(0, 2);

    }
    if (this.cellPhoneRep) {
      this.cellPhoneRep = this.cellPhoneRep.replace(/\D/g, '');
      this.cellPhoneRep = this.cellPhoneRep.substring(0, 11);

    }
    if (this.phoneRep) {
      this.phoneRep = this.phoneRep.replace(/\D/g, '');
      this.phoneRep = this.phoneRep.substring(0, 11);

    }
    if (this.accountNumber) {
      this.accountNumber = this.accountNumber.replace(/\D/g, '');
      this.accountNumber = this.accountNumber.substring(0, 25);
      this.disableSaveButton = !(/^\d{5,25}$/.test(this.accountNumber));    //condicion que valida el campo numero de cuenta y si la expresion regular se cumple devuelve false, lo que habilita el boton guardar
    }

  }
  
  
  validateOnlyNumbersArray(index: number) {
    const contact = this.contacts[index];
    if (contact.phone) {
      contact.phone = contact.phone.replace(/\D/g, '');
    }
  }

  selectCheckbox(checkboxIndex: number) {
    this.typeProviderId = checkboxIndex;
    this.select = true;
    const checkboxCount = 5;
    for (let i = 0; i < checkboxCount; i++) {
      if (i !== checkboxIndex) {
        const checkboxElement = document.getElementsByClassName('checkbox2')[i] as HTMLIonCheckboxElement;
        checkboxElement.checked = false;
      }
    }
  }

  async addContact() {
    this.contacts.push({});

  }

  async removeContact(index: number) {
    this.contacts.splice(index, 1);
  }


  async addSocialNeworks() {
    this.socialNetworkn.push({});

  }

  async removeSocialNeworks(index: number) {
    this.socialNetworkn.splice(index, 1);
  }


  changeRuntFile(event: any) {
    if (!this.providerId) {
      this.providerId = localStorage.getItem(Constant.providerId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        const data = {route: res.url};
        this.urlRutUploaded = res.url;
        this.adminService.createDocuments(data, this.providerId, null, null
        ).subscribe((day: any) => {
        })
        this.isFormDocuments = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeIdPhotocopyFile(event: any) {
    if (!this.providerId) {
      this.providerId = localStorage.getItem(Constant.providerId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlIdPhotocopyUploaded = res.url;
        this.adminService.createDocuments(data, this.providerId, null, null).subscribe((day: any) => {
        })
        this.isFormDocuments = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();

      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }
  }

  changeBankCertificationFile(event: any) {
    if (!this.providerId) {
      this.providerId = localStorage.getItem(Constant.providerId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlBankCertificationUploaded = res.url;
        this.adminService.createDocuments(data, this.providerId, null, null).subscribe((day: any) => {
        })
        this.isFormDocuments = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }

  }

  changeContractFile(event: any) {
    if (!this.providerId) {
      this.providerId = localStorage.getItem(Constant.providerId);
    }
    this.loading.present();
    if (event.target.files[0]) {
      this.fileType = event.target.files[0].type;
      console.log(event.target.files[0]);
      this.adminService.uploadFile(event.target.files[0], 'advertising').subscribe((res: any) => {
        let data = {route: res.url};
        this.urlContractUploaded = res.url;
        this.adminService.createDocuments(data, this.providerId, null, null).subscribe((day: any) => {
        })
        this.isFormDocuments = true;
        this.presentToast('Documento guardado con éxito');
        this.loading.dismiss();
      }, error => {
        console.warn(error);
        this.loading.dismiss();
      });
    }

  }

  async basicData(data) {
    await this.loading.present();
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    this.registeredBy = userId;
    data.registeredBy = this.registeredBy;
    data.classCiiu = this.selectedActivity.classCiiu;  
    // @ts-ignore
    data.isNaturalPerson = this.flagNaturalPerson === 'true' || this.flagNaturalPerson === true;
    this.authService.createProviders(data).subscribe((response: any) => {
      localStorage.setItem(Constant.providerId, response.providerId);
      localStorage.setItem(Constant.entityId, response.entityId);
      this.providerId = response.providerId;
      this.loading.dismiss();
      this.presentToast('Datos básicos fueron guardados con éxito');
      this.isFormBasicDataComplete = true;
      this.ngForm.reset();
      this.close(true);
    }, error => {
      console.warn('Error al guardar datos básicos', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar datos básicos');
    });


  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'primary',
    });
    toast.present();
  }

  async close(data: any) {
    await this.modalController.dismiss(data);
  }

  getTypeaccountbank() {
    this.loading.present();
    this.adminService.getTypeaccountbank().subscribe((res: any) => {
      this.typeaccounts = res;
      console.log(this.typeaccounts)
      this.loading.dismiss();
    });
  }

  getBanks() {
    this.loading.present();
    this.adminService.getBanks().subscribe((res: any) => {
      this.banks = res;
      console.log(this.banks)
      this.loading.dismiss();
    });
  }

  getCountries() {
    this.loading.present();
    this.adminService.getCountries().subscribe((res: any) => {
      this.countries = res;
      console.log(this.countries);
      this.loading.dismiss();
    });
  }

  getDepartmentsCountries(countryId?) {
    this.loading.present();
    this.adminService.getDepartments(countryId).subscribe((res: any) => {
      this.departments = res;
      this.loading.dismiss();
    });
  }

  getCities(departmentId?) {
    this.loading.present();
    this.adminService.getCities(departmentId).subscribe((res: any) => {
      this.cities = res;
      this.loading.dismiss();
    });
  }

  getBusinessActivityCiiu() {
    this.loading.present();
    this.adminService.getSupplierBusinessActivityCiiu().subscribe((res: any) => {
      this.activities = res;
      console.log(this.activities);
      this.loading.dismiss();
    });
  }

  filterActivities(event: any) {
    const searchTerm = event.target.value.toLowerCase();
  
    if (searchTerm.length >= 2) {
      this.filteredActivities = this.activities.filter(activity =>
        activity.name.toLowerCase().includes(searchTerm) ||
        activity.classCiiu.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredActivities = [];
    }
  }

  selectActivity(activity: any) {
    this.selectedActivity = activity;
    this.filteredActivities = [];
    console.log('Esta es la actividad seleccionada:', this.selectedActivity);  
  }

  getTypeProviders() {
    this.loading.present();
    this.adminService.getSupplierTypeProviders().subscribe((res: any) => {
      this.typeProviders = res;
      console.log(this.typeProviders);
      this.loading.dismiss();
    });
  }

  getFiscalResponsibility() {
    this.loading.present();
    this.adminService.getFiscalResponsibility().subscribe((res: any) => {
      this.taxRegimes = res;
      console.log(this.typeProviders);
      this.loading.dismiss();
    });

  }

  getTypeIdentificationId() {
    this.loading.present();
    this.adminService.getTypeIdentificationId().subscribe((res: any) => {
      this.documents = res;
      console.log(this.documents);
      this.loading.dismiss();
    });
  }

  getAreaDirectories() {
    this.loading.present();
    this.adminService.getContactAreaDirectories().subscribe((res: any) => {
      this.areas = res;
      console.log(this.areas);
      this.loading.dismiss();
    });
  }


  async saveContact() {
    const providerId = localStorage.getItem(Constant.providerId);
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    this.contacts.forEach(contact => {
      contact.registeredBy = userId;
      this.adminService.createContacts(contact, providerId, null, null).subscribe(res => {
          console.log(res);
          this.presentToast('Datos básicos de contactos guardados con éxito');
          this.isFormContacts = true;
          this.ngForm.reset();

        }, error => {
          console.warn('Error al guardar contactos', error);
          this.loading.dismiss();
          this.presentToast('Error al guardar contactos');
        }
      );
    });
  }

  getSocialNetworks() {
    this.loading.present();
    this.adminService.getSocialNetworks().subscribe((res: any) => {
      this.socialNetworks = res;
      console.log(this.socialNetworks);
      this.loading.dismiss();
    });
  }


  async accountingInformation(value) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 3000
    });
    await loading.present();
    await this.loading.present();
    if (!this.providerId) {
      this.providerId = localStorage.getItem(Constant.providerId);
    }
    // @ts-ignore
    if (this.flagNaturalPerson === 'false') {
      value.identificationTypeRepId = value.typeIdentificationId
    }

    const userId = localStorage.getItem('user_id');
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    value.registeredBy = userId;

    value.taxRegimeId = this.taxRegimeId
    this.authService.updateProvider(this.providerId, value).subscribe(response => {
      console.log(this.providerId, value);

      this.loading.dismiss();
      this.presentToast('Datos contables fueron guardados con éxito');
      this.isFormAccountingInformation = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar datos contables', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar datos contables');
    }
    );

    this.adminService.saveBankInformationProvider(this.providerId, value).subscribe(response => {
      console.log(this.providerId, value);
      this.loading.dismiss();
      this.isFormAccountingInformation = true;
      this.close(true);
    }, error => {
      console.warn('Error al guardar informacion bancaria', error);
      this.loading.dismiss();
      this.presentToast('Error al guardar la información bancaria');
    });

  }


  getSocialMediaUrl(id: any) {
    if (this.socialNetworks) {
      const socialNetwotk = this.socialNetworks.filter(i => i.socialNetworkId === id);
      if (socialNetwotk.length > 0) {
        const url = socialNetwotk[0].logoUrl;
        console.log('return img', url);
        return url;
      }
    }
  }

  async saveInformationNeworks() {
    const providerId = localStorage.getItem(Constant.providerId);
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.error('User ID no está disponible');
      return;
    }
    this.socialNetworkn.forEach(socialNetwork => {
      socialNetwork.registeredBy = userId;
      socialNetwork.webPage = this.webPage;
      this.adminService.createInformationNeworks(socialNetwork, providerId).subscribe(res => {
          console.log(res);
          this.presentToast('Datos redes sociales guardados con éxito');
          this.isFormSocialNetworkn = true;
        }, error => {
          console.warn('Error al guardar redes sociales', error);
          this.loading.dismiss();
          this.presentToast('Error al guardar redes sociales');
        }
      );
    });

  }

  selectCheckbox2(checkboxIndex: number) {
    this.taxRegimeId = checkboxIndex;
    this.select = true;
    const checkboxCount = 5;
    for (let i = 0; i < checkboxCount; i++) {
      if (i !== checkboxIndex) {
        const checkboxElement = document.getElementsByClassName('checkbox3')[i] as HTMLIonCheckboxElement;
        checkboxElement.checked = false;
      }
    }
  }


  changeCountry(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getDepartmentsCountries(event.detail.value);
    }
  }

  changeDepartment(event: any) {
    if (event && event.detail && event.detail.value) {
      this.getCities(event.detail.value);
    }
  }

  openUrl(url) {
    if (url) {
      window.open(url);
    }
  }

  getPaymentMethods() {
    this.loading.present();
    this.adminService.getPaymentMethods().subscribe((res: any[]) => {
      this.paymentMethods = res;
      this.loading.dismiss();
    });
  }



  getTypeCourtsFrequencies() {    //extrae los tipos de corte
    this.loading.present();
    this.adminService.getTypesCourt().subscribe((res: any[]) => {
      this.typeCourts = res;
      this.loading.dismiss();
    });
  }

  getTypesSettlement() {    //extrae los tipos de liquidacion
    this.loading.present();
    this.adminService.getTypesSettlement().subscribe((res: any[]) => {
      this.typeSettlement = res;
      this.loading.dismiss();
      console.log(this.typeSettlement);

    });
  }

  getConfigCourt(){    //extrae las configuraciones de corte
    this.loading.present();
    this.adminService.getCourts().subscribe((res: any[]) => {
      this.originalConfigCourt = res;
      this.configCourt = res;       
      console.log('se cargaron los config court en el original', this.originalConfigCourt);
      this.loading.dismiss();
      console.log('asi quedo el que se usara',this.configCourt);
    });
  }

  saveConditions() {
    this.isFormStatements = true;
    this.presentToast('Declaraciones Guardadas');

  }

  async saveCourtConfig(value: any) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    loading.present();
    try {
        let frequency;                 //consulta en la lista de cortes extraidos de base cual coincide con el nombre ó Id del corte seleccionado
        if (value.frequency === 'Semanal' || value.frequency === 'Quincenal' || value.frequency === 'Diario') {
          if(value.frequency === 'Semanal') { 
            const sunday = 'Semanal - Día Domingo';   //si es semanal toma unicamente el valor del dia que se hara el corte
            frequency = this.configCourt.filter(i => i.name === sunday);
          } else {
            frequency = this.configCourt.filter(i => i.name === value.frequency); //si no es semanal no hara cambio
          }
        } else if (value.frequency === 'Mensual' ) {
          frequency = this.configCourt.filter(i => i.courtId === value.dayMonth);        //en estos casos busca el corte con el dia seleccionado en la segunda lista desplegable
        } else if (value.frequency === 'Días de la semana') {
          frequency = this.configCourt.filter(i => i.courtId === value.dayWeek);
        }
      const frequencyId =
                        { courtId: frequency[0].courtId,
                          updatedBy: localStorage.getItem('user_id') } 

      const entityId = localStorage.getItem(Constant.entityId);
      console.log('Configuración De Corte A Guardar ', frequencyId);
      this.adminService.createCourtConfig(frequencyId, entityId).subscribe(data => {
        this.presentToast('Configuración de corte guardada');
        console.log('Esta Es La Configuración De Facturación Registrada', data);
        this.isFormPayments = true;
      }, error => {
        console.error('No se pudo realizar la configuración de cortes ', error);
        this.presentToast('No se pudo registrar la configuración de cortes');
      });
    } catch (error) {
      console.error('Error al guardar la configuración de cortes: ', error);
      this.presentToast('No se pudo registrar la configuración de cortes');
    } finally {
      loading.dismiss();
    }
  }

  async savePaymentMethod(value) {
    const loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    loading.present(); 
    try {
      const payload = { 
        entityId: localStorage.getItem(Constant.entityId),
        paymentMethodId: value.paymentMethod ,
        settlementTypeId: value.billingMethod,
        updatedBy: localStorage.getItem('user_id'),
      };
      if(!this.validatePayload(payload)) {
        throw new Error('Información insuficiente, todos los campos deben estar completos');
      }
      this.authService.paymentMethodForEntity(payload).subscribe( response => {
        this.presentToast('Datos de facturación guardados con éxito');
        this.loading.present();
        this.isFormBilling = true;
      }, error => {
        console.error('No se pudo realizar la configuración de facturación: ', error);
        this.loading.dismiss();
        this.presentToast('No se pudo registrar la configuración de facturación');
      });
    } catch (error) {
      console.error('Error al guardar la configuración de facturación: ', error);
      this.presentToast('No se pudo registrar la configuración de facturación');
    } finally {
      loading.dismiss();
    }
  }

 
  filterConfigCourtByFrequency(selectedValue: string) {
    this.filteredConfigCourt = [];
    let targetName;
    console.log('cargare los datos', this.originalConfigCourt);
    let configCourtCopy =this.originalConfigCourt.slice() ; // Haciendo una copia de configCourt
    switch(selectedValue) {
      case 'Diario':
      case 'Quincenal':
          this.filteredConfigCourt.push(configCourtCopy.find(court => court.name === selectedValue));
          break;
      
      case 'Días de la semana':
          targetName = (selectedValue === 'Días de la semana') ? 'Semanal' : selectedValue;
          this.splitName(targetName, configCourtCopy); // Pasando la copia de configCourt
          break;

      case 'Mensual':
        this.splitName(selectedValue, configCourtCopy); // Pasando la copia de configCourt
        break;

      case 'Semanal':
        targetName = 'Semanal - Dia Domingo';
        this.splitName(targetName, configCourtCopy); // Pasando la copia de configCourt
        break;
    }
    console.log('lo que hay en el arreglo filtrado', this.filteredConfigCourt);

  }

  splitName(targetName, configCourtCopy) {
    for (const court of configCourtCopy) { // Usando la copia de configCourt
        if (court.name.startsWith(targetName)) {
            const splitName = court.name.split(' - ');
            if (splitName.length > 1) {
                const courtCopy = JSON.parse(JSON.stringify(court));
                courtCopy.name = splitName[1].trim(); //- Modificar la copia profunda
                this.filteredConfigCourt.push(courtCopy);
            } else {
                this.filteredConfigCourt.push(court);
            }
        }
    }
  }

  validatePayload(payload: any): boolean {
    for (const key in payload) {
      if (payload[key] === null || payload[key] === undefined || payload[key] === '') {
        return false;
      }
    }
    return true;
  }
}